import React, { ReactNode } from 'react';
import { ButtonBase, ButtonBaseProps, styled } from '@mui/material';
import { useCobrand } from 'features/cobrand/hooks/useCobrandUtils';

interface NavbarLogoProps extends ButtonBaseProps {
  brandLogo: ReactNode;
  onBrandLogoClick: () => void;
}

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  '& .MuiTouchRipple-root': {
    color: theme.palette.action.focus,
  },
}));

export const NavbarLogo = ({ brandLogo, onBrandLogoClick, ...restProps }: NavbarLogoProps) => {
  const { cobrand } = useCobrand();
  return (
    <StyledButtonBase
      role="link"
      focusRipple
      onClick={onBrandLogoClick}
      {...restProps}
      aria-label={`${cobrand.displayName} logo`}
    >
      {brandLogo}
    </StyledButtonBase>
  );
};
